import pako from 'pako';

interface LoadOptions {
  useGzip?: boolean;
}

export async function loadJSON<T>(
  path: string,
  options: LoadOptions = {}
): Promise<T> {
  const url = options.useGzip ? `${path}.gz` : path;
  
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to load ${url}: ${response.statusText}`);
    }
    
    const data = options.useGzip
      ? await decompressGzip(await response.arrayBuffer())
      : await response.json();
    
    return data as T;
  } catch (error) {
    // Fallback to non-gzipped if gzip fails
    if (options.useGzip) {
      return loadJSON<T>(path, { useGzip: false });
    }
    throw error;
  }
}

async function decompressGzip(buffer: ArrayBuffer): Promise<any> {
  const decompressed = pako.inflate(new Uint8Array(buffer), { to: 'string' });
  return JSON.parse(decompressed);
}

